/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PushSubscriptionCreate interface.
 */
export function instanceOfPushSubscriptionCreate(value) {
    if (!('endpoint' in value) || value['endpoint'] === undefined)
        return false;
    if (!('p256dh' in value) || value['p256dh'] === undefined)
        return false;
    if (!('auth' in value) || value['auth'] === undefined)
        return false;
    return true;
}
export function PushSubscriptionCreateFromJSON(json) {
    return PushSubscriptionCreateFromJSONTyped(json, false);
}
export function PushSubscriptionCreateFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'endpoint': json['endpoint'],
        'p256dh': json['p256dh'],
        'auth': json['auth'],
    };
}
export function PushSubscriptionCreateToJSON(json) {
    return PushSubscriptionCreateToJSONTyped(json, false);
}
export function PushSubscriptionCreateToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'endpoint': value['endpoint'],
        'p256dh': value['p256dh'],
        'auth': value['auth'],
    };
}
